import { IconSquareLayoutGrid3Outline18 as TilesIcon } from "nucleo-ui-outline-18"

import type {} from "@productlane/lib/src/tiptap/extensions/mintlify/tile"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const tilesCommand: SlashCommandDefinition = {
	key: "tiles",
	title: "Tiles",
	icon: <TilesIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertTiles(3).run()
	},
	group: "blocks",
	aliases: ["tile", "tiles", "preview", "gallery", "showcase", "grid"],
}
